import { showCustomToast } from 'common/components/CustomToast/utils';
import { useMutation, useQuery } from '@apollo/client';
import {
  Dropdown,
  IDropdownOption,
  Label,
  Stack,
  TextField,
} from '@fluentui/react';
import { ConfirmDialog } from 'common/components/ConfirmDialog';
import React, { useState } from 'react';

import { ApprovalHistoryBranches_approvalHistoryBranches_nodes } from '../__generated__/ApprovalHistoryBranches';

import { useStyles } from './index.styles';

import AVAILABLE_APPROVER_LIST from '../AvailableEntityApproverList.graphql';
import ADD_APPROVER from './AddEntityApprover.graphql';
import APPROVAL_HOSTORY_BRANCHES from '../ApprovalHistoryBranches.graphql';
import GET_APPROVAL_HISTORY_DETAILS from '../../ApprovalHistory.graphql';
import {
  AddEntityApprover,
  AddEntityApproverVariables,
} from './__generated__/AddEntityApprover';

interface AddNewApproverModalProps {
  onDismiss: () => void;
  entityApprovalId: string | undefined;
  entityItem: ApprovalHistoryBranches_approvalHistoryBranches_nodes | undefined;
  approverListOptions: IDropdownOption<any>[];
}
export const AddNewApproverModal: React.FC<AddNewApproverModalProps> = ({
  onDismiss,
  entityApprovalId,
  entityItem,
  approverListOptions,
}) => {
  const styles = useStyles();
  const [newApprover, setNewApprover] = useState<string | undefined>(undefined);
  const [reason, setReason] = useState<string | undefined>(undefined);

  const [addApprover, { loading: loadingAddApprover }] = useMutation<
    AddEntityApprover,
    AddEntityApproverVariables
  >(ADD_APPROVER, { errorPolicy: 'all' });

  const _onConfirm = async () => {
    const { errors } = await addApprover({
      variables: {
        input: {
          entityBranchId: entityItem?.id!,
          rowTimestamp: entityItem?._rowTimestamp!,
          originalUserProfileId: entityItem?.approverUserProfileId!,
          reason: reason!,
          newUserProfileId: newApprover,
        },
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: APPROVAL_HOSTORY_BRANCHES,
          variables: {
            id: entityApprovalId!,
          },
        },
        {
          query: GET_APPROVAL_HISTORY_DETAILS,
          variables: {
            id: entityApprovalId!,
          },
        },
        {
          query: AVAILABLE_APPROVER_LIST,
          variables: {
            entityApprovalId: entityApprovalId!,
          },
        },
      ],
    });
    if (errors?.length) {
      showCustomToast({
        content: errors[0].message,
        appearance: 'error',
      });
    } else {
      onDismiss();
      showCustomToast({
        content: `Approver added successfully`,
        appearance: 'success',
      });
    }
  };
  const disableConfirmButton = !reason || loadingAddApprover || !newApprover;
  return (
    <ConfirmDialog
      isConfirmPrimaryButton
      successBtnDisable={disableConfirmButton}
      hidden={false}
      title={`Add Approver - ${entityItem?.approverName}`}
      onDismiss={onDismiss}
      minWidth={450}
      onConfirm={_onConfirm}
    >
      <Stack tokens={{ childrenGap: '10px', padding: '20px 0px 20px 0px' }}>
        <Stack horizontal tokens={{ childrenGap: 20 }}>
          <Label className={styles.width100}>New Approver</Label>
          <Dropdown
            placeholder="Select"
            className={styles.dropdownStyles}
            options={approverListOptions}
            onChange={(_, option) => {
              setNewApprover(option?.key as string);
            }}
          />
        </Stack>

        <Stack horizontal tokens={{ childrenGap: 20 }}>
          <Label className={styles.width100}>Reason for Addition</Label>
          <TextField
            className={styles.textInputStyle}
            multiline
            rows={3}
            value={reason}
            placeholder="Please write your reason here"
            resizable={false}
            onChange={(_event, value) => setReason(value || '')}
          />
        </Stack>
      </Stack>
    </ConfirmDialog>
  );
};
